import getPostTypeStaticPaths from '@/functions/wp/posts/getPostTypeStaticPaths';
import getPostTypeStaticProps from '@/functions/wp/posts/getPostTypeStaticProps';

const postType = 'podcast';

/**
 * Render the Post component
 *
 * @param  {object}  props      component attributes as props
 * @param  {object}  props.post post data from WP
 * @return {Element}            Post component
 */
// eslint-disable-next-line react/prop-types
export default function Post({ post }) {
  // eslint-disable-next-line react/prop-types
  return <h1>{post?.title}</h1>;
}

/**
 * Get post static paths.
 *
 * @return {object} Array of paths and fallbacks
 */
export async function getStaticPaths() {
  return getPostTypeStaticPaths(postType);
}

/**
 * Get post static props
 *
 * @param  {object} context        context for current post
 * @param  {object} context.params route parameters for current post
 * @return {object}                post props
 */
export async function getStaticProps({ params }) {
  return getPostTypeStaticProps(params, postType);
}
